import React from "react";

const DownloadIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1 8.33325L1.1559 8.77496C1.76267 10.4941 2.06605 11.3537 2.75828 11.8435C3.45051 12.3333 4.36206 12.3333 6.18518 12.3333H7.81482C9.63794 12.3333 10.5495 12.3333 11.2417 11.8435C11.934 11.3537 12.2373 10.4941 12.8441 8.77496L13 8.33325" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
            <path d="M6.99992 8.33329V1.66663M6.99992 8.33329C6.5331 8.33329 5.66094 7.00376 5.33325 6.66663M6.99992 8.33329C7.46674 8.33329 8.3389 7.00376 8.66659 6.66663" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default DownloadIcon;